import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

import { IonApp, IonRouterOutlet } from "@ionic/vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    fallback: _withCtx(() => [
      _createTextVNode(" Loading... ")
    ]),
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet))
        ]),
        _: 1
      }))
    ]),
    _: 1
  }))
}
}

})